export const airlinesOptions = 
[
    { "id": 1, "name": "ANA All Nippon Cargo" },
    { "id": 2, "name": "Aeroflot PJSC" },
    { "id": 3, "name": "Air Arabia" },
    { "id": 4, "name": "Air Asia X" },
    { "id": 5, "name": "Air Astana" },
    { "id": 6, "name": "Air Canada" },
    { "id": 7, "name": "Air France" },
    { "id": 8, "name": "Air India" },
    { "id": 9, "name": "Air Mauritius" },
    { "id": 10, "name": "Air India Express" },
    { "id": 11, "name": "Akasa Air" },
    { "id": 12, "name": "Alitalia" },
    { "id": 13, "name": "Alliance Air Air India" },
    { "id": 14, "name": "American Airlines" },
    { "id": 15, "name": "Armenian Airlines" },
    { "id": 16, "name": "Azerbaijan Airlines" },
    { "id": 17, "name": "Belavia Belarusian Airlines" },
    { "id": 18, "name": "Bhutan Airlines" },
    { "id": 19, "name": "Biman Bangladesh Airlines" },
    { "id": 20, "name": "British Airways" },
    { "id": 21, "name": "Cambodia Angkor Air" },
    { "id": 22, "name": "Cathay Dragon" },
    { "id": 23, "name": "Cathay Pacific Airways" },
    { "id": 24, "name": "Drukair Airline" },
    { "id": 25, "name": "EGYPTAIR" },
    { "id": 26, "name": "Emirates" },
    { "id": 27, "name": "Ethiopian Airlines" },
    { "id": 28, "name": "Etihad Airways" },
    { "id": 29, "name": "Finnair" },
    { "id": 30, "name": "Flydubai" },
    { "id": 31, "name": "Flynas Company" },
    { "id": 32, "name": "Gulf Air" },
    { "id": 33, "name": "Indigo Airlines" },
    { "id": 34, "name": "Iraqi Airways" },
    { "id": 35, "name": "Japan Airlines" },
    { "id": 36, "name": "Jazeera Airways" },
    { "id": 37, "name": "KLM Royal Dutch Airlines" },
    { "id": 38, "name": "Korean Air" },
    { "id": 39, "name": "Kuwait Airways" },
    { "id": 40, "name": "LOT Polish Airlines" },
    { "id": 41, "name": "Lufthansa airline" },
    { "id": 42, "name": "Mahan Air" },
    { "id": 43, "name": "Malaysian Airline" },
    { "id": 44, "name": "Malindo Air" },
    { "id": 45, "name": "Myanmar Airlines" },
    { "id": 46, "name": "Nepal Airlines" },
    { "id": 47, "name": "Oman Air" },
    { "id": 48, "name": "Qantas Airways" },
    { "id": 49, "name": "Qatar Airways" },
    { "id": 50, "name": "Royal Jordanian" },
    { "id": 51, "name": "Salam Air" },
    { "id": 52, "name": "SalamAir" },
    { "id": 53, "name": "Saudi Arabian Airlines" },
    { "id": 54, "name": "Simon Air" },
    { "id": 55, "name": "Singapore Airlines" },
    { "id": 56, "name": "Spice Jet" },
    { "id": 57, "name": "SriLankan Airlines" },
    { "id": 58, "name": "Swiss Air Lines" },
    { "id": 59, "name": "Thai Airasia X" },
    { "id": 60, "name": "Thai Airways" },
    { "id": 61, "name": "Turkish Airlines" },
    { "id": 62, "name": "Turkmenistan Airlines" },
    { "id": 63, "name": "United Airlines" },
    { "id": 64, "name": "Uzbekistan Airways" },
    { "id": 65, "name": "VietJet Air" },
    { "id": 66, "name": "Vietnam Airlines" },
    { "id": 67, "name": "Virgin Atlantic Airway" },
    { "id": 68, "name": "Batik Air Malaysia" },
    { "id": 69, "name": "Fly 91" },
    { "id": 70, "name": "Star Air" },
    { "id": 71, "name": "VietJet Aviation Joint" },
    { "id": 72, "name": "Thai Air Asia" },
    { "id": 73, "name": "Royal Dutch Airways" },
    { "id": 74, "name": "Nok Air" }
  ]
  